/*
 * filename: routers.tsx
 * mainly responsible for all routes component
 */

import React from 'react';
import history from '../history';
import { Route } from 'react-router-dom';
import { Router } from 'react-router';
import RoutesComponent from './routesComponent';

const Routers: React.FC = () => {
  return (
    <Router history={history}>
      <Route component={RoutesComponent} />
    </Router>
  );
};

export default Routers;
